import { render } from "./RuleDelete.vue?vue&type=template&id=68114c98&scoped=true"
import script from "./RuleDelete.vue?vue&type=script&lang=js"
export * from "./RuleDelete.vue?vue&type=script&lang=js"

import "./RuleDelete.vue?vue&type=style&index=0&id=68114c98&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68114c98"]])

export default __exports__